module.exports = __webpack_public_path__ + "img/scrolldown.f37ea9ce.svg";